import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/assets/{-$id}')({
  beforeLoad: () => getTitleContextSlice('Assets'),
  staticData: {
    owner: CodeOwner.Assets,
  },
});
